import { motion } from "framer-motion";
import { ShieldCheck, BadgePoundSterling, MapPin, Star } from "lucide-react";

const items = [
  { icon: ShieldCheck, label: "Fully insured" },
  { icon: BadgePoundSterling, label: "Free, no-obligation quotes" },
  { icon: MapPin, label: "Washington & the North East" },
  { icon: Star, label: "5-star rated by locals" },
];

export const TrustStrip = () => {
  return (
    <section className="bg-brand-orange">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 grid grid-cols-2 md:grid-cols-4 divide-x divide-black/10">
        {items.map((it, i) => (
          <motion.div
            key={it.label}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08, duration: 0.5 }}
            className="flex items-center justify-center gap-3 px-3 py-2 text-center"
          >
            <it.icon size={20} className="text-black shrink-0" />
            <span className="font-heading font-medium text-black text-sm md:text-base leading-tight">{it.label}</span>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
